import { Suspense } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { useCurrentSessionQuery } from '@/features/auth/authApi';
import { RouteFallback } from '@/components/Spinner';
import { routes } from '@/app/routes';

const router = createBrowserRouter(routes);

export function App() {
  // Resolves the httpOnly session cookie into user state before any guard
  // runs. Errors are expected here — a signed-out visitor simply 401s.
  useCurrentSessionQuery();

  return (
    <Suspense fallback={<RouteFallback />}>
      <RouterProvider router={router} />
    </Suspense>
  );
}
